<template>
    <Transition name="fade-in" @after-enter="afterEnter" @after-leave="afterLeave">
      <div class="dialog" v-show="isActive">
        <Transition appear name="fade-in-content">
          <div class="dialog_holder">
            <slot></slot>
          </div>
        </Transition>
        <button
          class="dialog_close"
          v-if="isClosable"
          id="close-button"
          @click="handleCloseButton"
        >
          {{ $t('Close') }}
        </button>
      </div>
    </Transition>
</template>

<script>
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'

/**
 * Basic Overlay for Dialogs and Popups
 */
@Component
class Overlay extends Vue {
  @Prop({ type: Boolean, default: true }) isClosable
  @Mutation('ui/SET_SCROLL_LOCK') setScrollLock

  isActive = false
  emitterId = null

  mounted () {
    this.open()
  }

  beforeDestroy () {
    this.close()
  }

  open () {
    this.isActive = true
    this.setScrollLock(true)
    document.addEventListener('keydown', this.onKeyDown)
  }

  /**
   * @fires open
   */
  afterEnter () {
    this.$emit('open')
  }

  // fired when user click on close button
  handleCloseButton (event) {
    this.close(event.currentTarget.id)
  }

  close (emitterId = null) {
    this.isActive = false
    this.emitterId = emitterId
    this.setScrollLock(false)
    document.removeEventListener('keydown', this.onKeyDown)
  }

  /**
   * @fires close
   */
  afterLeave () {
    this.$emit('close', this.emitterId)
  }

  onKeyDown (event) {
    // handle ESC keydown
    if (this.isClosable && event.keyCode === 27) {
      this.close()
    }
  }
}

export default Overlay
</script>

<style lang="scss">
.dialog {
  background: #141414;
  bottom: 0;
  right: 0;
  top: 0;
  left: 0;
  padding: 65px 0;
  position: fixed;
  overflow: auto;
  z-index: $common-menu_z-index + 1;

  &_holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100%;
    margin: 0 auto;
    padding: 0 30px;
  }
  &_close {
    @extend %close-button;
  }
}

/*
  Overlay transitions
  Based on Animation Kit rules
  https://confluence.lesta.group/display/PLATFORM/Animation+kit
*/
// delay for content and close button
$button-fadein-delay: $animation-delay + $duration;

.fade-in-enter,
.fade-in-leave-to,
.fade-in-content-enter {
  opacity: 0;
}

.fade-in-enter-active,
.fade-in-leave-active,
.fade-in-content-enter-active {
  transition: all $duration ease-in;
}

.fade-in-content-enter-active {
  transition-delay: $button-fadein-delay;
}
</style>
